import { Box, useToast } from "@chakra-ui/react";
import { useAuth } from "@the-volte/svc-core-sdk";
import React from "react";
import { AiFillExclamationCircle, AiOutlineClose } from "react-icons/ai";

import { IconButton, Tile } from "@components/atoms";
import { keycloakRealm, siteUrl } from "@temp/constants";

import * as S from "./styles";

export const PasswordTile: React.FC = () => {
  const { authenticated, loaded, user } = useAuth();
  const toast = useToast();

  const getBaseUrl = () => {
    if (siteUrl.includes("localhost") || siteUrl.includes("svc-proxy"))
      return siteUrl;

    const normalizeUrl = siteUrl.replace(".co.uk", ".com");
    return normalizeUrl;
  };

  const baseUrl = getBaseUrl();
  const marketplaceUri = encodeURIComponent(`${siteUrl}/account`);
  const changePasswordRoute = `${baseUrl}/auth/realms/${keycloakRealm}/account/password?marketplace_uri=${marketplaceUri}`;

  return (
    <S.TileWrapper>
      <Tile contentProps={{ style: { padding: 0 } }}>
        <S.Wrapper>
          <S.Content>
            <a
              href={changePasswordRoute}
              onClick={(e) => {
                if (!authenticated || !loaded || !user) {
                  e.preventDefault();
                  toast({
                    duration: 3000,
                    position: "top-right",
                    render: () => (
                      <Box
                        alignItems="center"
                        backgroundColor="#fff"
                        boxShadow="dark-lg"
                        color="red"
                        display="flex"
                        flexDir="row"
                        gap={2}
                        padding={3}
                      >
                        <AiFillExclamationCircle />
                        Please log in to update your personal details or
                        password.
                        <AiOutlineClose
                          cursor="pointer"
                          onClick={() => toast.closeAll()}
                        />
                      </Box>
                    ),
                  });
                }
              }}
            >
              <IconButton
                testingContext="editDetailsButton"
                name="edit"
                size={22}
              />
              Click here to update your personal details or password
            </a>
          </S.Content>
        </S.Wrapper>
      </Tile>
    </S.TileWrapper>
  );
};
